import { mapState } from 'vuex'

export const PRODUCTS_SITUATION_ID = 1
export const EXHIBITS_SITUATION_ID = 2
export const MAIL_MAGAZINE_MEMBERS_SITUATION_ID = 3
export const GLOSSARY_SITUATION_ID = 4

export default {
  data: function () {
    return {
      postTypes: [
        { id: 0, type: 'normal', typeJa: '通常記事' },
        {
          id: 1,
          type: 'product',
          typeJa: '商品記事',
          siteSituations: [PRODUCTS_SITUATION_ID]
        }
      ]
    }
  },
  computed: {
    ...mapState({
      siteExtensionPermissions: (state) =>
        state.SiteStore.siteExtensionPermissions
    }),
    selectablePostTypes () {
      return this.postTypes.filter((postType) => {
        if (!postType.siteSituations) {
          return true
        }
        if (
          postType.siteSituations &&
          this.isPermittedAll(postType.siteSituations)
        ) {
          return true
        }
        return false
      })
    }
  },
  methods: {
    isPermittedAll (situations) {
      return (
        situations.filter((situation) => this.isPermitted(situation)).length ===
        situations.length
      )
    },
    isPermitted (situation) {
      switch (situation) {
        case PRODUCTS_SITUATION_ID:
          return (
            this.siteExtensionPermissions.findIndex(
              (permission) =>
                permission.siteExtensionObject.id === PRODUCTS_SITUATION_ID
            ) !== -1
          )
        case EXHIBITS_SITUATION_ID:
          return (
            this.siteExtensionPermissions.findIndex(
              (permission) =>
                permission.siteExtensionObject.id === EXHIBITS_SITUATION_ID
            ) !== -1
          )
        case MAIL_MAGAZINE_MEMBERS_SITUATION_ID:
          return (
            this.siteExtensionPermissions.findIndex(
              (permission) =>
                permission.siteExtensionObject.id === MAIL_MAGAZINE_MEMBERS_SITUATION_ID
            ) !== -1
          )
        case GLOSSARY_SITUATION_ID:
          return (
            this.siteExtensionPermissions.findIndex(
              (permission) =>
                permission.siteExtensionObject.id === GLOSSARY_SITUATION_ID
            ) !== -1
          )
        default:
          return false
      }
    }
  }
}
